const photoLinks = {
    carouselPhotos: [
        {
            imageSrc: 'https://www.expocafeperu.com/w/2019/11/vasque-breeze-iii-mid-gtx-womens-vasque-breeze-iii-gtx-low-review-vasque-boots-vasque-womens-breeze-iii-gtx-waterproof-hiking-boot.jpg',
            caption: "Discover the World Around You!",
            altText: 'Carousel item',
        },
        {
            imageSrc: 'https://www.switchbacktravel.com/sites/default/files/images/articles/Hiking%20Boots%20%28Lowa%20Renegade%20GTX%20on%20rock%29.jpg',
            caption: "",
            altText: 'Carousel item',
        },
    ],
    homepageEvents: {
        newShoesCoverPhoto: {
            imageSrc: "https://blog.fitbit.com/wp-content/uploads/2016/01/012716_Sneakers_Blog_730x485_WDB.jpg",
            altText: "Go to New Shoes"
        },
        specialOffersCoverPhoto: {
            imageSrc: "https://xeroshoes.com/wp-content/themes/xeroshoes/assets/images/hero/xero_hero_sm2.png",
            altText: "Go to Special Offers"
        }
    },
    homepageCategories: [
        { name: "Running", imageSrc: "https://thumbor.forbes.com/thumbor/960x0/https%3A%2F%2Fspecials-images.forbesimg.com%2Fimageserve%2F5efca684531e1500073c686a%2FRunning-Shoes-On-Running%2F960x0.jpg%3Ffit%3Dscale" },
        { name: "Mountain", imageSrc: "https://www.switchbacktravel.com/sites/default/files/images/articles/Hiking%20Shoe%20%28Salomon%20X%20Ultra%203%29.jpg" },
        { name: "Walking", imageSrc: "http://www.gallowayglens.org/wp-content/uploads/2016/07/08-group-walking.jpg" },
        { name: "Gym", imageSrc: "https://s3.amazonaws.com/images.gearjunkie.com/uploads/2020/12/Best-Crossfit-Shoes-2.jpg" },
        { name: "Formal", imageSrc: "https://veganmenshoes.com/wp-content/uploads/2019/06/vegan-dress-shoes-for-men-best-mens-cruelty-free-vegetarian-leather-fake-faux-formal-casual-brown-black-sustainable-eco-friendly-synthetic-manmade-top-2019.jpg" },
        { name: "Children", imageSrc: "https://denver.cbslocal.com/wp-content/uploads/sites/14984641/2015/08/shutterstock_186259364.jpg" },
    ],
    specialOffers: [
        "https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/articles/health_tools/different_athletic_shoe_types_slideshow/493ss_thinkstock_rf_running_shoes.jpg",
        "https://cdn3.volusion.com/wumnz.wxzmz/v/vspfiles/photos/hokagaviotatwow-9T.jpg?v-cache=1620200594",
        "https://hokaoneone.com.au/wp-content/uploads/2020/08/chalatr5_feature.jpg",
        "https://hokaoneone.com.au/wp-content/uploads/2021/01/clifton7_s21_feature.jpg"
    ],
    aboutUs: "https://cdn.winfieldsoutdoors.co.uk/wp-content/uploads/2014/11/walking-shoes-sunday.jpg",
    categories: {
        Running: {
            categoryName: "Running",
            imageUrls: [
                "https://media.cntraveler.com/photos/603e8e5eb3c7f5651f698239/16:9/w_2560%2Cc_limit/BestRunningSneakers-2021-Hoka-Lede.jpg",
                "https://cdn1.coachmag.co.uk/sites/coachmag/files/styles/16x9_480/public/2019/12/stability-running-shoes-saucony-guide-13.jpg",
                "https://cdn1.coachmag.co.uk/sites/coachmag/files/styles/16x9_480/public/2020/03/saucony-kinvara-11-running-shoes.jpg",
                "https://cdn2.coachmag.co.uk/sites/coachmag/files/styles/insert_main_wide_image/public/2020/03/saucony-kinvara-11.jpg",
                "https://i2.keller-sports.com/guide/en/2020/06/The-new-ASICS-Metaracer-running-shoes-in-Running-Test-2020.jpg",
            ]
        },
        Mountain: {
            categoryName: "Mountain",
            imageUrls: [
                "https://www.rankandstyle.com/media/lists/w/womens-hiking-boots-and-shoes.jpg",
                "https://my-test-11.slatic.net/p/7/women39s-outdoor-sports-shoes-hiking-shoes-mountain-climbing-shoes-trekking-shoes-warm-fur-winter-shoes-high-top-casual-shoes-tourist-shoes-6207-88387279-dad46690027fb5c0773e03a0b6ce5d50-catalog.jpg_720x720q80.jpg_.webp",
                "https://i.pinimg.com/originals/94/dd/d9/94ddd98976244d13563fab6250646e26.jpg",
                "https://www.dhresource.com/600x600/f2/albu/g8/M01/04/D9/rBVaV11j40WAcY9jAAdOn3cERes381.jpg",
                "https://www.switchbacktravel.com/sites/default/files/images/articles/Hiking%20Boots%20%28Lowa%20Renegade%20GTX%20on%20rock%29.jpg",
            ]
        },
        Walking: {
            categoryName: "Walking",
            imageUrls: [
                "https://lilostyle.com/wp-content/uploads/2020/09/boots-for-women-15979.jpg",
                "https://www.thestatesman.com/wp-content/uploads/2018/05/shoes-walking.jpg",
                "https://blog.vionicshoes.com/wp-content/uploads/2020/12/zeliyah-blog.png",
                "https://www.mcall.com/resizer/ySrXaMtbHQJJg0HGZODDsFlU_K8=/415x233/top/arc-anglerfish-arc2-prod-tronc.s3.amazonaws.com/public/RSOSPKFYUFF5RMOJBLRTDRYLSY.jpg",
                "https://embed.widencdn.net/img/veritas/nvy2npc4hd/1200x675px/walking-sand.jpg",
            ]
        },
        Gym: {
            categoryName: "Gym",
            imageUrls: [
                "https://res.cloudinary.com/webstore/image/fetch/w_450,c_limit,c_fit,f_auto,e_trim/https%3A%2F%2Fae01.alicdn.com%2Fkf%2FHTB1sYvbbL1H3KVjSZFHq6zKppXaw%2FFitness-Sneakers-men-Gym-Trainers-Outdoor-New-Men-s-Shoes-Mesh-Shoes-Leisure-Sports-Shoes-Are.jpg",
                "https://img.joomcdn.net/14e99d76646d39e4aa6ff597fc54cb61a57d05d3_original.jpeg",
                "https://symbolofhope.com/wp-content/uploads/2019/05/jonathan-borba-1339221-unsplash-1000x1000.jpg",
                "https://images.yaoota.com/zN0B-k9Wz_tfov8qRu-f5Wz4EwI=/trim/yaootaweb-production-ke/media/crawledproductimages/a6191ac656ef84c88db686c2ff1f819cf78fc83b.jpg",
                "https://static.vecteezy.com/system/resources/previews/001/241/427/non_2x/healthy-lifestyle-runner-tying-running-shoes-getting-ready-for-race-on-run-track-jog-workout-wellness-concept-free-photo.jpg",
            ]
        },
        Formal: {
            categoryName: "Formal",
            imageUrls: [
                "https://cdn11.bigcommerce.com/s-pkla4xn3/images/stencil/1280x1280/products/20791/183149/DXKZMCM-Men-Dress-Shoes-Men-Formal-Shoes-Leather-Luxury-Wedding-Shoes-Men-Oxford-Shoes-Big-Size__44375.1545975495.jpg?c=2?imbypass=on",
                "https://i.pinimg.com/736x/08/14/76/0814764582e38b3450317266dad3b94f.jpg",
                "https://res.cloudinary.com/webstore/image/fetch/w_450,c_limit,c_fit,f_auto,e_trim/https%3A%2F%2Fae01.alicdn.com%2Fkf%2FHa482884c8dec4959b36d8f93245af685g%2FFormal-Shoes-Leather-Men-Dress-Shoes-wedding-Fashion-Brand-Luxury-Men-s-Business-Casual-Classic-Gentleman.jpg",
                "https://assets.ajio.com/medias/sys_master/root/h5f/h8d/11139842310174/-1117Wx1400H-460185188-brown-MODEL.jpg",
                "https://assets.ajio.com/medias/sys_master/root/h01/ha5/11139255304222/-473Wx593H-460185177-brown-MODEL.jpg",
            ]
        },
        Children: {
            categoryName: "Children",
            imageUrls: [
                "https://i.pinimg.com/736x/d7/c6/e6/d7c6e65179fb6113af3a745c3739072f.jpg",
                "https://cf.shopee.ph/file/5814404f06126209d406ba70be161cbc_tn",
                "https://img.alicdn.com/imgextra/i2/2186352762/TB2z3zgcdcnBKNjSZR0XXcFqFXa_!!2186352762.jpg",
                "https://i.pinimg.com/originals/20/03/3b/20033b5d404ab3b0a42bf618bf9bb676.jpg",
                "https://clarks.scene7.com/is/image/Pangaea2Build/db-uk-kids-trainers-sq-wk22-ss21?wid=460&fmt=pjpg",
            ]
        },
    }
}

export default photoLinks;